import {defineStore} from 'pinia'
import {replaceData} from "@spoferan/spoferan-ts-core";
import {AreaSection} from "../types/AreaSection";

/***********************************************************
 Vuex Section Store
 --------------------------
 Store to use for detail and sub-pages of a section.
 ************************************************************/
export const useSectionStore = defineStore('section', {
    state: () => ({
        /**
         * The current section details to show.
         */
        section: {} as AreaSection,
    }),

    actions: {
        /**
         * Replaces the state's section details with the specified data.
         */
        replaceSectionData(data: AreaSection) {
            // We need to replace the full target object at once to trigger a full reactive reload of the corresponding components
            this.section = replaceData({...this.section}, data);
        },

        /**
         * Sets the specified data on the state's section details.
         */
        setSectionData(data: AreaSection) {
            this.section = data;
        },

        /**
         * Loads the details of the section with the specified key from the server and sets it on the store.
         */
        async loadSection(areaKey: string | number, sectionKey: string | number, params = {}) {
            try {
                const {data} = await useApiFetch(`/v1/guide/${areaKey}/sections/${sectionKey}`, {
                    params: params
                });
                this.replaceSectionData(data);
            } catch (e) {
                throw e
            }
        }
    }
});